var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimePicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5C10.1159 12.682 10 14.5 12 15H6C8 14.5 7.88566 12.6957 8.5 10.5",
    stroke: "#FD9E2E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H12V16V17H6V16V15Z",
    stroke: "#FD9E2E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48795 1.31321C8.53334 1.21964 8.60564 1.14045 8.69635 1.08497C8.78706 1.02948 8.89241 1 9 1C9.10759 1 9.21293 1.02948 9.30365 1.08497C9.39436 1.14045 9.46666 1.21964 9.51205 1.31321L10.8637 4.11402C10.9043 4.19775 10.9664 4.27016 11.0444 4.32436C11.1223 4.37856 11.2134 4.41276 11.3089 4.42371L14.5026 4.79119C14.6097 4.80353 14.7108 4.845 14.794 4.9107C14.8773 4.97639 14.9392 5.06357 14.9725 5.16193C15.0057 5.2603 15.0089 5.36573 14.9817 5.46579C14.9545 5.56585 14.898 5.65635 14.8189 5.7266L12.461 7.82405C12.3904 7.88684 12.3376 7.96593 12.3078 8.0538C12.278 8.14167 12.2721 8.23539 12.2907 8.32606L12.9128 11.3535C12.9335 11.4548 12.9236 11.5597 12.8843 11.6557C12.845 11.7518 12.7778 11.8351 12.6908 11.8958C12.6038 11.9565 12.5005 11.9921 12.3931 11.9984C12.2857 12.0047 12.1786 11.9815 12.0845 11.9314L9.27485 10.428C9.19081 10.3831 9.0962 10.3595 9 10.3595C8.9038 10.3595 8.80919 10.3831 8.72515 10.428L5.91641 11.9314C5.8223 11.9817 5.71514 12.0052 5.60757 11.999C5.5 11.9929 5.39651 11.9573 5.30933 11.8966C5.22214 11.8358 5.15489 11.7524 5.11553 11.6562C5.07616 11.5599 5.06632 11.4549 5.08715 11.3535L5.70933 8.32606C5.72804 8.23547 5.7223 8.14179 5.69264 8.05393C5.66299 7.96607 5.61041 7.88693 5.5399 7.82405L3.18109 5.7266C3.10198 5.65635 3.04549 5.56585 3.01828 5.46579C2.99108 5.36573 2.99429 5.2603 3.02755 5.16193C3.0608 5.06357 3.12271 4.97639 3.20596 4.9107C3.28921 4.845 3.39033 4.80353 3.49736 4.79119L6.69107 4.42371C6.78665 4.41276 6.87772 4.37856 6.95564 4.32436C7.03356 4.27016 7.09574 4.19775 7.13629 4.11402L8.48795 1.31321Z",
    stroke: "#FD9E2E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17H13",
    stroke: "#FD9E2E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimePicked);
export default __webpack_public_path__ + "static/media/prime-picked.2d1adac5b52895dec033dce8663070bb.svg";
export { ForwardRef as ReactComponent };